import { render } from "./PlaLeiteStatusSelect.vue?vue&type=template&id=09573d2a"
import script from "./PlaLeiteStatusSelect.vue?vue&type=script&lang=js"
export * from "./PlaLeiteStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__